import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '@core/_services/subscription/subscription.service';
import { AuthService } from '@modules/auth/_services/auth.service';
import { PaymentSubscriptionStatus } from '@core/models/interfaces/subscription.interface';

@Component({
  selector: 'app-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.scss'],
})
export class SubscriptionBannerComponent implements OnInit {
  status: PaymentSubscriptionStatus;
  validUntilDate: string | null;

  constructor(
    private subscriptionService: SubscriptionService,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    const currentUser = this.authService.currentUserValue;

    this.status = currentUser?.profile?.company?.subscription?.status ?? PaymentSubscriptionStatus.INACTIVE;
    this.validUntilDate = currentUser?.profile?.company?.subscription?.valid_until ?? null;
  }

  onActivatePlan(): void {
    this.subscriptionService.openSubscriptionDialog();
  }

  shouldShowBanner(): boolean {
    if (this.status !== PaymentSubscriptionStatus.INACTIVE && this.status !== PaymentSubscriptionStatus.TRIAL) {
      return false;
    }

    // Si no hay fecha de validez, asumimos que la suscripción es inactiva
    if (!this.validUntilDate) {
      return true;
    }

    const validUntilDate = new Date(this.validUntilDate);
    const currentDate = new Date();

    // Calculate difference in milliseconds
    const timeDiff = validUntilDate.getTime() - currentDate.getTime();

    // If time has already passed, don't show banner
    if (timeDiff <= 0) {
      return false;
    }

    const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));

    // Show banner if 5 or fewer days remaining
    return (this.status === PaymentSubscriptionStatus.INACTIVE || this.status === PaymentSubscriptionStatus.TRIAL)
      && daysRemaining <= 5;
  }
}
